// HeroSection.jsx - OPTION 2: Different Images for Mobile/Desktop

import React from 'react';
import styles from './HeroSection.module.css';
import Header from './Header';
import HeroImage from '../assets/images/HeroImage.jpg';
import HeroImageMobile from '../assets/images/hero-mobile.webp'; // Create this mobile-optimized image

const HeroSection = ({ pageTitle = "HOME" }) => {
  return (
    <div className={styles.heroContainer}>
      <div className={styles.backgroundContainer}>
        {/* Desktop Background Image */}
        <img
          src={HeroImage}
          alt="Hair salon background"
          className={`${styles.backgroundImage} ${styles.desktopImage}`}
        />
        
        {/* Mobile Background Image */}
        <img
          src={HeroImageMobile}
          alt="Hair salon background"
          className={`${styles.backgroundImage} ${styles.mobileImage}`}
        />
        
        {/* Overlay */}
        <div className={styles.overlay} />
        
        {/* Header */}
        <div className={styles.headerWrapper}>
          <Header />
        </div>
        
        {/* Main Content */}
        <div className={styles.contentWrapper}>
          <div className={styles.contentInner}>
            <div className={styles.htdfContainer}>
              {/* HTDF Brand Text */}
              <h1 className={styles.htdfText}>
                HTDF
              </h1>
              
              {/* Page Title Overlay */}
              {pageTitle !== "HOME" && (
                <div className={styles.pageTitle}>
                  {pageTitle}
                </div>
              )}
            </div>
            
            {/* Subtitle */}
            {pageTitle === "HOME" && (
              <p className={styles.subtitle}>
                Extension & Color Lounge
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;